export const ratingList = [
    { value: 0, label: "Low", chipColour: "#44CE82" },
    { value: 1, label: "Medium", chipColour: "#EAC24F" },
    { value: 2, label: "High", chipColour: "#EBA240" },
    { value: 3, label: "Critical", chipColour: "#E46164" },
];
